package pl.decks.chartjs.radar.options.plugins

import pl.decks.chartjs.color.ChartColor
import pl.decks.chartjs.jsConstructors.jso
import pl.decks.chartjs.model.ChartJSOption
import pl.decks.chartjs.model.JSScriptable
import pl.decks.chartjs.radar.options.FontOptions

data class LegendTitleOptions(
    val display: Boolean = false,
    val text: String? = null,
    val color: JSScriptable<ChartColor>? = null,
    val font: FontOptions? = null,
    val padding: Int? = null,
) : ChartJSOption {
    override fun toChartJs(): dynamic = jso {
        this.display = display.asDynamic()
        if (text != null) this.text = text.asDynamic()
        if (color != null) this.color = color.toChartJs { it.toChartJs() }
        if (font != null) this.font = font.toChartJs()
        if (padding != null) this.padding = padding.asDynamic()
    }
}
